import React, { createContext, useContext, useMemo, useState } from 'react';
import { useLocalStorage } from '@client/hooks/use-local-storage';
import { useIsomorphicLayoutEffect } from '@isomorphic/hooks/use-isomorphic-layout-effect';
import { initialWidth, defaultWidth } from '@layout/components/Navigation/components/ResizableAside/ResizableAside';

type AsideWidthType = {
  asideWidth: number;
  setAsideWidth: React.Dispatch<React.SetStateAction<number>>;
};

export const AsideWidthContext = createContext<AsideWidthType>({
  asideWidth: 300,
  setAsideWidth: () => {},
});

export const useAsideWidthContext = () => useContext(AsideWidthContext);

export const AsideWidthProvider = ({ children }) => {
  const [storageWidth] = useLocalStorage('asideWidth', defaultWidth, initialWidth);
  const [asideWidth, setAsideWidth] = useState(storageWidth);

  useIsomorphicLayoutEffect(() => {
    setAsideWidth(storageWidth);
  }, [storageWidth]);

  const value = useMemo(() => ({ asideWidth, setAsideWidth }), [asideWidth]);

  return <AsideWidthContext.Provider value={value}>{children}</AsideWidthContext.Provider>;
};
